import { IntroScreenUIConfig } from "../components/ui/intro-screen-ui";
import { SingleScenarioInfoConfig } from "../components/ui/scenario-info-ui";
import { GeneralQuestionUIConfig, GeneralQuestionUIConfigOption } from "../cvp-webgames-core/Components/ui/react/core-general-question-ui";
import GameManager from "../cvp-webgames-core/GameManager";
import Tools from "../cvp-webgames-core/Misc/Tools";
import BaseScenarioPart from "../cvp-webgames-core/Scenario/BaseScenarioPart";
import { VideoSegmentItem, SingleVideoSegmentItem } from "../cvp-webgames-core/VideoSegment/VideoSegmentItem";
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from "../cvp-webgames-core/pre-caching/pre-cache-item";
import { constants } from "../misc/constants";
import { CustomGameDataManager, PageType, updateMentorVideo } from "../misc/tools";
import { GameBaseScenario } from "./GameBaseScenario";

class Scenario3VideoSegments extends VideoSegmentItem {
	public get title(): string {
		return 'Domiciliary Exam Room Racial & Derogatory Slurs';
    }

	public videoKey = 'Video';
	public get mentorVidUrl(): string {
		return this.getItems()[1].src;
	}

	public cinematicKeys = {
		chapter1: 'chapter1', //played on step 2
		chapter1Resume: 'chapter1-resume',

		chapter2: 'chapter2', //played on step 5
		chapter2Resume: 'chapter2-resume',

		chapter3: 'chapter3', //played on step 7
		chapter3Resume: 'chapter3-resume',

		chapter4: 'chapter4', //played on step 9
		chapter4Resume: 'chapter4-resume',
    };

	public mentorKeys = {
		situation: 'mentor-2', //played on situation screen
		mentor1Correct: 'mentor-1', //played on ____ correct
		mentor1Incorrect: 'mentor-1', //played on ____ incorrect
		review: 'mentor-3', //played on review screen
		BnScn03All001: 'Bn-Scn-03-All-001',
		BnScn03All007: 'Bn-Scn-03-All-007',
		BnScn03All010: 'Bn-Scn-03-All-010',
		BnScn03All012: 'Bn-Scn-03-All-012',
		BnScn03All015: 'Bn-Scn-03-All-015',
		BnScn03All017: 'Bn-Scn-03-All-017',
		BnScn03All019: 'Bn-Scn-03-All-019',
		BnScn03All020: 'Bn-Scn-03-All-020',
		BnScn03All022: 'Bn-Scn-03-All-022',
		BnScn03All024: 'Bn-Scn-03-All-024',
		BnScn03All026: 'Bn-Scn-03-All-026',
		BnScn03All029: 'Bn-Scn-03-All-029',
		BnScn03All033: 'Bn-Scn-03-All-033',
		BnScn03All035: 'Bn-Scn-03-All-035',
		BnScn03All036: 'Bn-Scn-03-All-036',
		BnScn03All038: 'Bn-Scn-03-All-038',
		BnScn03All040: 'Bn-Scn-03-All-040',
		BnScn03All041: 'Bn-Scn-03-All-041',
		BnScn03All043: 'Bn-Scn-03-All-043',
		BnScn03All045: 'Bn-Scn-03-All-045',
		BnScn03All047: 'Bn-Scn-03-All-047',
		BnScn03All049: 'Bn-Scn-03-All-049',
		BnScn03All050: 'Bn-Scn-03-All-050',
		BnScn03All052: 'Bn-Scn-03-All-052',
		BnScn03All058: 'Bn-Scn-03-All-058',
		BnScn03All060: 'Bn-Scn-03-All-060',
		BnScn03All062: 'Bn-Scn-03-All-062',
		BnScn03All064: 'Bn-Scn-03-All-064',
		BnScn03All065: 'Bn-Scn-03-All-065',
		BnScn03All067: 'Bn-Scn-03-All-067',
		BnScn03All069: 'Bn-Scn-03-All-069',
		BnScn03All071: 'Bn-Scn-03-All-071',
		BnScn03All073: 'Bn-Scn-03-All-073',
		BnScn03All075: 'Bn-Scn-03-All-075',
		BnScn03All078: 'Bn-Scn-03-All-078',
		BnScn03All081: 'Bn-Scn-03-All-081',
		BnScn03All083: 'Bn-Scn-03-All-083',
		BnScn03All085: 'Bn-Scn-03-All-085',
		BnScn03All087: 'Bn-Scn-03-All-087',
		BnScn03All088: 'Bn-Scn-03-All-088',
		BnScn03All091: 'Bn-Scn-03-All-091',
		BnScn03All093: 'Bn-Scn-03-All-093',
		BnScn03All094: 'Bn-Scn-03-All-094',
		BnScn03All096: 'Bn-Scn-03-All-096',
		BnScn03All098: 'Bn-Scn-03-All-098',
		BnScn03All101: 'Bn-Scn-03-All-101',
		BnScn03All103: 'Bn-Scn-03-All-103',
		BnScn03All106: 'Bn-Scn-03-All-106',
		BnScn03All107: 'Bn-Scn-03-All-107',
		BnScn03All108: 'Bn-Scn-03-All-108',
		BnScn03All109: 'Bn-Scn-03-All-109',
		BnScn03All110: 'Bn-Scn-03-All-110',
    };
	
	public getItems(): SingleVideoSegmentItem[] {
		return [
			{
				key: this.videoKey,
				src: process.env.PUBLIC_URL + '/assets/videos/scenario-03/video.mp4',
				type: PrecacheItemType.Video
			},
			{
				key: 'Feedback',
				src: process.env.PUBLIC_URL + '/assets/mentor-vids/scn-03/Mentor-Bs-Scn-03-Full.mp4',
				type: PrecacheItemType.Video
			}
		];
	}
}

export const scenario3VideoSegments = new Scenario3VideoSegments();

export default class Scenario3 extends GameBaseScenario {
	public partId = 'scenario';
	
	public getScenarioInfo(): SingleScenarioInfoConfig {
		return null;
    }

	public get MentorTalkingVideo(): string {
		return scenario3VideoSegments.mentorVidUrl;
    }

	public resumeScenarioFromArea(areaIndx: number): void {
		Tools.getSaveData().then((savedData: CustomGameDataManager) => {
			this.hudId = this.uiWrapper.displayHUD({
			});
			//resume on or after the first question
			let onDone: () => void = null;
			let chapterId: string = null;
			switch(areaIndx) {
				case 0:
					chapterId = scenario3VideoSegments.cinematicKeys.chapter1Resume;
					onDone = () => this.step4();
					break;
				case 1:
					chapterId = scenario3VideoSegments.cinematicKeys.chapter2Resume;
					onDone = () => this.step6();
					break;
				case 2:
					chapterId = scenario3VideoSegments.cinematicKeys.chapter3Resume;
					onDone = () => this.step8();
					break;
				case 3:
					chapterId = scenario3VideoSegments.cinematicKeys.chapter4Resume;
					onDone = () => this.step10();
					break;
				case 4:
					chapterId = scenario3VideoSegments.cinematicKeys.chapter4Resume;
					onDone = () => this.step12();
					break;
			}
	
			setTimeout(() => {
				this.playVideoChapter(this.partId, chapterId, () => {
					onDone();
				}, false)
			}, 250);
		});
	}

	public scenarioIndex(): number {
		return 2;
    } 

	public scenarioId(): PageType {
		return PageType.Scenario3;
    }
	private video: SingleVideoSegmentItem = scenario3VideoSegments.getItemByKey(scenario3VideoSegments.videoKey);

	public getScenarioVideoURL(): string {
		return this.video.src;
	}


	public introScreenInfo(): IntroScreenUIConfig {
		return null
	}

	private parts: BaseScenarioPart<GameBaseScenario>[] = [{
		partId: this.partId,
		scenario: this,
		videoUrl: [scenario3VideoSegments.getItemByKey(scenario3VideoSegments.videoKey).src],
		start: () => {
		},
		playVideoChapter: (chapterId: string, onDone: () => void) => {
			(this.playVideoChapter(this.partId, chapterId, onDone, false))
		}
	}]

	constructor(gameManager: GameManager, scenarioName: string) {
		super(gameManager, scenarioName);
	}

	start() {
		this.step0();
	}

	public getParts(): BaseScenarioPart<GameBaseScenario>[] {
		return this.parts;
	}

	public getSoundPath(fileName: string): string {
		return process.env.PUBLIC_URL + '/assets/audio/scenario1/' + fileName + '.ogg';
	}

	//load video
	step0() {
		// this.loadPart(this.partId, () => {
			this.step1();
		// });
	}

	//1.	Scenario Intro
	step1() {
		updateMentorVideo(true, scenario3VideoSegments.mentorVidUrl, scenario3VideoSegments.mentorKeys.BnScn03All001);
		this.hudId = this.uiWrapper.displayHUD({
		});
		this.uiWrapper.displayIntroScreenUI({
			title: 'Situation',
			buttonText: 'Continue',
			htmlData: `
			<div>
				<p class="black-text">
					You are a clinician walking down the hall in the domiciliary. As you walk by one of the exam rooms you hear 
					Veteran Samuel Pickens engaging in a loud discussion with two nurses. You approach the room to hear Veteran 
					Pickens getting increasingly louder and using racially insensitive comments. Veteran Pickens is upset with the 
					two nurses because he felt he should have been able to get his PRN medications earlier than the computer system indicates.
				</p>
				<br />
				<p class="black-text">
					The goal will be to identify the ERASE techniques, bystander intervention techniques, requirements outlined in VHA 
					Directive 5019.02, and VA Handbook 5979 throughout the scenario. You are the only other clinician available on the 
					unit right now as all the other Veterans and staff are attending a group meeting.
				</p>
			</div>
			`,
			spaceForMentor: true,
			audioUrls: null,
			onStartScenarioClicked: () => {
				this.step2();
			}
		})
	}

	//2.	Cinematic 1 (Video)
	step2() {
		this.playVideoChapter(this.partId, scenario3VideoSegments.cinematicKeys.chapter1, () => {
			this.step3();
			this.step4();
		}, false)
	}

	//3.	Display UI
	step3() {
		
	}

	//4.	Question 1
	step4(customOptions?: GeneralQuestionUIConfigOption[]) {
		updateMentorVideo(false, scenario3VideoSegments.mentorVidUrl, scenario3VideoSegments.mentorKeys.BnScn03All007);
		const options = customOptions ?? [{
			title: 'Option 1',
			mentorVid: scenario3VideoSegments.mentorVidUrl,
			mentorOption: [scenario3VideoSegments.mentorKeys.BnScn03All010],
			isCorrect: false,
			description: 'You ignore the loud voices. If there are two nurses in the room, they are fine.',
			feedbackHtml: 'Not the best answer! As a part of the ERASE model, you should (E)xpect that disruptive events are likely to happen in the unit. This decision also ignores the (R)ecognition that these types of behaviors are out of context for the unit and may indicate something more concerning. By ignoring these types of situations, there could be Veterans or staff who could be in an unsafe situation and unable to get the help they need. Ignoring the behavior does not ensure safety or respect in the unit. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario3VideoSegments.mentorKeys.BnScn03All012]
		}, {
			title: 'Option 2',
			mentorVid: scenario3VideoSegments.mentorVidUrl,
			mentorOption: [scenario3VideoSegments.mentorKeys.BnScn03All015],
			isCorrect: true,
			description: 'You go to the room and stand outside the door to listen to the situation before you intervene. You cannot see who is in the room, or what is going on.',
			feedbackHtml: 'Correct! While this does allow you to get closer to the situation and assess what needs the people have in the situation; it also allows you to determine if this is a fully safe or unsafe situation. The E in the ERASE model is for Expect. You can already expect that there may be unwelcome or unsafe behavior on the unit, and you need to go investigate. The R in the ERASE model is for Recognize. You have recognized that what you are hearing is an irregular sound on the unit, and you should potentially do something to intervene.',
			mentorFeedback: [scenario3VideoSegments.mentorKeys.BnScn03All017]
		}, {
			title: 'Option 3',
			mentorVid: scenario3VideoSegments.mentorVidUrl,
			mentorOption: [scenario3VideoSegments.mentorKeys.BnScn03All019, scenario3VideoSegments.mentorKeys.BnScn03All020],
			isCorrect: true,
			description: 'You walk into the room, identify yourself, and are in line sight of Veteran Pickens and the two nurses. You can see the safety issues, and clearly hear the conversation. Your goal is to de-escalate. You ask: "Is everything okay, can I help?"',
			feedbackHtml: 'Correct! You have considered the first two letters of the ERASE model: (E) is for expect and (R) is for recognize. By expecting situations to arise, you will be better prepared to address all different types of behaviors. You also will be more likely to recognize unwelcome and unsafe behaviors on the unit. You will be more aware of how to call for help and where the panic alarms are. You will have most likely also taken Bystander Intervention Training so you can safely intervene with the four D\'s if necessary. The four D\'s stand for: Direct- Address the harasser with a short statement or questions to point out the threatening or inappropriate behavior in a safe, respectful manner; Distract- Use a subtle and creative way to draw or divert attention. Directly engage the person being harassed without getting involved with the harasser or referring to the harassment. Instead, talk about something completely unrelated; Delegate- Get assistance from a third party; and Document- Write down the details of the incident.',
			mentorFeedback: [scenario3VideoSegments.mentorKeys.BnScn03All022]
		}, {
			title: 'Option 4',
			mentorVid: scenario3VideoSegments.mentorVidUrl,
			mentorOption: [scenario3VideoSegments.mentorKeys.BnScn03All024],
			isCorrect: false,
			description: 'You immediately call for VA Police assistance. There are raised voices on the unit, and you do not want to get involved.',
			feedbackHtml: 'Not the best answer! This is likely too strong of a response as a preliminary intervention. It is normal to feel apprehensive or uncomfortable when voices are escalating. Without knowing the situation or what is happening, you do not know what type of assistance is needed. By calling the VA police immediately, you may lose an opportunity to intervene at a less-restrictive level and avoid escalating the situation. If you have safety concerns for yourself, patients(s), or other staff contacting the VA police is an appropriate first action. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario3VideoSegments.mentorKeys.BnScn03All106]
		}]
		this.uiWrapper.displayQuestonType1UI({
			title: PageType.Scenario3,
			subtitle: ('Question 1'),
			audioUrl: null,
			options:options,
			multipleChoice: false,
			questionTitle: 'Select the response that best aligns with your action. There may be more than one appropriate response.',
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario3VideoSegments.getItemByKey('Feedback');
				this.onQuestionType1Submitted(allOptions, selectedChoices, parentQuestionConfig,
												 () => { //Next Step (if correct)
													this.step5();
												 }, (optionsToShow: GeneralQuestionUIConfigOption[]) => { //Next Step (if incorrect)
													this.step4(optionsToShow);
												 }, mentorInfo.src);
			}
		}, 0, 1, () => this.step2())
	}

	//5.	Time passes
	step5() {
		this.playVideoChapter(this.partId, scenario3VideoSegments.cinematicKeys.chapter1Resume, () => {
			//UNCOMMENT FOR MENTOR
			updateMentorVideo(true, scenario3VideoSegments.mentorVidUrl, scenario3VideoSegments.mentorKeys.BnScn03All029);
			this.uiWrapper.displayIntroScreenUI({
				title: 'Information',
				buttonText: 'Continue',
				htmlData: `
				<div>
					<p class="black-text">
						You move forward into line of sight of the medication area. You can see Veteran Pickens and two nurses. 
						Veteran Pickens is yelling about his medications. He says:
					</p>
				</div>
				`,
				audioUrls: null,
				spaceForMentor: true,
				onStartScenarioClicked: () => {
					this.step5b();
				}
			})
		}, false)
		
	}

	//5b.	Cinematic 2 (Video)
	step5b() {
		this.playVideoChapter(this.partId, scenario3VideoSegments.cinematicKeys.chapter2, () => {
			this.step6();
		}, false)
	}

	//6.	Question 2
	step6(customOptions?: GeneralQuestionUIConfigOption[]) {
		updateMentorVideo(false, scenario3VideoSegments.mentorVidUrl, scenario3VideoSegments.mentorKeys.BnScn03All033);
		const options = customOptions ?? [{
			title: 'Option 1',
			mentorVid: scenario3VideoSegments.mentorVidUrl,
			mentorOption: [scenario3VideoSegments.mentorKeys.BnScn03All035, scenario3VideoSegments.mentorKeys.BnScn03All036],
			isCorrect: true,
			description: 'You walk into the room and tell Veteran Pickens with a calm and quieter voice that both his language and his tone are not appropriate for the mental health recovery setting. You state to Veteran Pickens: “You are clearly upset, nursing staff want to support your needs; however, we have to treat them professionally and respectfully. Please understand, nursing staff are unable to order medications. Knowing that will you share with me how we can support your needs?”',
			feedbackHtml: 'Correct! You are setting a clear boundary that his language is not acceptable nor is his yelling and addressing this in real time. The ERASE model encourages you to: Address the concerns in real time. You are demonstrating how to engage appropriately and encouraging the Veteran to continue to successfully get his needs met.',
			mentorFeedback: [scenario3VideoSegments.mentorKeys.BnScn03All038]
		}, {
			title: 'Option 2',
			mentorVid: scenario3VideoSegments.mentorVidUrl,
			mentorOption: [scenario3VideoSegments.mentorKeys.BnScn03All040, scenario3VideoSegments.mentorKeys.BnScn03All041],
			isCorrect: true,
			description: 'You walk into the room and draw attention to Veteran Pickens tone, you ask Veteran Pickens if he would like a glass of water or offer him a seat to sit down. You also say to the nursing staff: “I had a question I needed you two to answer. Do you mind stepping out in the hall with me for a moment?”',
			feedbackHtml: 'Correct! By engaging Veteran Pickens in this manner, you are utilizing the technique of distraction from the Bystander Intervention Training. Distraction is the use a subtle and creative way to draw away or divert attention. Directly engage the person being harassed without getting involved with the harasser or referring to the harassment. Instead, talk about something completely unrelated. This response does not address the inappropriate language or the tone in which Veteran Pickens is engaging with the nursing staff. It would be important if you use this technique to be sure that it is safe to leave the Veteran for a moment unattended.',
			mentorFeedback: [scenario3VideoSegments.mentorKeys.BnScn03All043]
		}, {
			title: 'Option 3',
			mentorVid: scenario3VideoSegments.mentorVidUrl,
			mentorOption: [scenario3VideoSegments.mentorKeys.BnScn03All045],
			isCorrect: false,
			description: 'You walk away. It\'s clear there are two nursing staff available to talk to Veteran Pickens, and one more person is really not going to help.',
			feedbackHtml: 'Not the best answer! This not addressing the situation in real time. It is important to be an active bystander. According to VHA Directive 5019.02 (3.c.3) "harassment is unlawful, unwelcome conduct based on race, color, sex (including gender identity or expression, transgender status, sexual orientation and pregnancy), religion, national origin, disability or age (over 40) and can include: the conduct can unreasonably interfere with an individual\'s work performance or create an intimidating, hostile, abusive or offensive work environment". Bystander intervention strategies help you to recognize and respond safely to a situation that is potentially hostile or to a behavior that may be harassing so that the situation does not get worse. Any individual who has been subjected to or witnessed unwelcome conduct is encouraged to use the Bystander intervention strategies to safely intervene or report unwelcome and offensive conduct. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario3VideoSegments.mentorKeys.BnScn03All107]
		}, {
			title: 'Option 4',
			mentorVid: scenario3VideoSegments.mentorVidUrl,
			mentorOption: [scenario3VideoSegments.mentorKeys.BnScn03All049, scenario3VideoSegments.mentorKeys.BnScn03All050],
			isCorrect: false,
			description: 'You walk into the room, and make your presence known. You state to Veteran Pickens: “You are clearly very upset by something. Everyone on this unit deserves to be treated professionally and respectfully by you and you need to stop all your yelling. We want to help you but can\'t if you\'re going to keep yelling. Can you just explain to me what is going on that has made you so mad?”',
			feedbackHtml: 'Not the best answer! This response does not address the behavior in a clinical or therapeutic manner. This approach is challenging and may be perceived as threatening to Veteran Pickens.',
			mentorFeedback: [scenario3VideoSegments.mentorKeys.BnScn03All052]
		}]
		this.uiWrapper.displayQuestonType1UI({
			title: PageType.Scenario3,
			subtitle: ('Question 2'),
			audioUrl: null,
			options:options,
			multipleChoice: false,
			questionTitle: 'Select the response that best aligns with your action. There may be more than one appropriate response.',
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario3VideoSegments.getItemByKey('Feedback');
				this.onQuestionType1Submitted(allOptions, selectedChoices, parentQuestionConfig,
												 () => { //Next Step (if correct)
													this.step7();
												 }, (optionsToShow: GeneralQuestionUIConfigOption[]) => { //Next Step (if incorrect)
													this.step6(optionsToShow);
												 }, mentorInfo.src);
			}
		}, 1, 2, () => this.step5())
	}

	//7.	Cinematic 3 (Video)
	step7() {
		this.playVideoChapter(this.partId, scenario3VideoSegments.cinematicKeys.chapter3, () => {
			this.step8();
		}, false)
	}

	//8.	Question 3
	step8(customOptions?: GeneralQuestionUIConfigOption[]) {
		updateMentorVideo(false, scenario3VideoSegments.mentorVidUrl, scenario3VideoSegments.mentorKeys.BnScn03All058);
		const options = customOptions ?? [{
			title: 'Option 1',
			mentorVid: scenario3VideoSegments.mentorVidUrl,
			mentorOption: [scenario3VideoSegments.mentorKeys.BnScn03All060],
			isCorrect: false,
			description: 'You tell Veteran Pickens that because of his behaviors and language, he cannot be taken care of by the staff, and you are going to be calling the VA police to discharge him immediately.',
			feedbackHtml: 'Not the best answer! This is way too strong of a response as a preliminary intervention. You may be feeling upset or reactive to a response like that from Veteran Pickens, and that is normal. While the first attempt to redirect didn\'t work, discharging Veteran Pickens at this point may be counterproductive to his treatment. By calling the VA police at this time may escalate the situation if there is no clear and present danger. If you have safety concerns for yourself, patients(s), or other staff contacting the VA police is an appropriate first action. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario3VideoSegments.mentorKeys.BnScn03All108]
		}, {
			title: 'Option 2',
			mentorVid: scenario3VideoSegments.mentorVidUrl,
			mentorOption: [scenario3VideoSegments.mentorKeys.BnScn03All064, scenario3VideoSegments.mentorKeys.BnScn03All065],
			isCorrect: true,
			description: 'You calmly address Veteran Pickens after you take a deep breath. You state: "All of us on the treatment team are here to provide you with the best quality care we can. We do appreciate your service. We want to continue to meet your needs and address whatever is bothering you but cannot continue unless you please lower your voice and use respectful language. I would be happy to see if we can get in touch with a provider to help us determine what we can do to meet your needs. Can you take a few minutes to take a walk with me while the nurses address the issue?"',
			feedbackHtml: 'Correct! You are addressing the concern in real time, and you are providing a supportive environment for both staff and Veterans to get the care they need. You set a clear boundary that his language and behaviors will not be tolerated. In the ERASE Model, you are utilizing the A for Addressing in real time and the S for supportive environment. Additionally, you are using the techniques of Direct and Distract from the Bystander Intervention Training.',
			mentorFeedback: [scenario3VideoSegments.mentorKeys.BnScn03All067]
		}, {
			title: 'Option 3',
			mentorVid: scenario3VideoSegments.mentorVidUrl,
			mentorOption: [scenario3VideoSegments.mentorKeys.BnScn03All069],
			isCorrect: true,
			description: 'You ask Veteran Pickens may you speak with him for a moment. You let him know that the two nurses are needed in the treatment room and they will need to finish assisting him once they are done there.',
			feedbackHtml: 'Correct! You are utilizing Distraction from the Bystander Intervention Training. This is the use a subtle and creative way to draw away or divert attention. Directly engage the person being harassed without getting involved with the harasser or referring to the harassment. Instead, talk about something completely unrelated. You may be feeling uncomfortable, defensive, or struggling to have a healthy response. It is ok to offer an opportunity for you and the other nursing staff to take a step back for a breather before re-engaging.',
			mentorFeedback: [scenario3VideoSegments.mentorKeys.BnScn03All071]
		}, {
			title: 'Option 4',
			mentorVid: scenario3VideoSegments.mentorVidUrl,
			mentorOption: [scenario3VideoSegments.mentorKeys.BnScn03All073],
			isCorrect: false,
			description: 'You yell back at Veteran Pickens. You let him know that he is acting absurd, and he is going to be discharged immediately.',
			feedbackHtml: 'Not the best answer! This is never an ok response. You may be feeling defensive or upset because what Veteran Pickens said was upsetting, however, managing and gaining control of your own emotions will help diffuse the situation instead of escalating it. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario3VideoSegments.mentorKeys.BnScn03All075]
		}]
		this.uiWrapper.displayQuestonType1UI({
			title: PageType.Scenario3,
			subtitle: ('Question 3'),
			audioUrl: null,
			options:options,
			multipleChoice: false,
			questionTitle: 'Select the response that best aligns with your action. There is more than one appropriate response.',
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario3VideoSegments.getItemByKey('Feedback');
				this.onQuestionType1Submitted(allOptions, selectedChoices, parentQuestionConfig,
												 () => { //Next Step (if correct)
													this.step9();
												 }, (optionsToShow: GeneralQuestionUIConfigOption[]) => { //Next Step (if incorrect)
													this.step8(optionsToShow);
												 }, mentorInfo.src);
			}
		}, 2, 3, () => this.step7())
	}

	//9.	Cinematic 4 (Video)
	step9() {
		this.playVideoChapter(this.partId, scenario3VideoSegments.cinematicKeys.chapter4, () => {
			this.step9b();
		}, false)
	}

	//9-b.	Time passes
	step9b() {
		//UNCOMMENT FOR MENTOR
		updateMentorVideo(true, scenario3VideoSegments.mentorVidUrl, scenario3VideoSegments.mentorKeys.BnScn03All078);

		this.uiWrapper.displayIntroScreenUI({
			title: 'Information',
			buttonText: 'Continue',
			htmlData: `
			<div>
				<p class="black-text">
					You empathize with Veteran Pickens assertion that there are a lot of rules and some of them the staff 
					cannot change. You let him know that we will follow up with the provider because you can hear that 
					he is experiencing pain, and that there needs to be an evaluation of what may be done that can address 
					it. Veteran Pickens walks back to his room.
				</p>
			</div>
			`,
			audioUrls: null,
			spaceForMentor: true,
			onStartScenarioClicked: () => {
				this.step10();
			},
			onReplayContentClicked: () => {
				this.step9();
			}
		})
	}

	//10.	Question 4
	step10(customOptions?: GeneralQuestionUIConfigOption[]) {
		updateMentorVideo(false, scenario3VideoSegments.mentorVidUrl, scenario3VideoSegments.mentorKeys.BnScn03All081);
		const options = customOptions ?? [{
			title: 'Option 1',
			isCorrect: false,
			description: 'You resume your rounding and regular check schedule.',
			mentorVid: scenario3VideoSegments.mentorVidUrl,
			mentorOption: [scenario3VideoSegments.mentorKeys.BnScn03All083],
			feedbackHtml: 'Not the best answer! This is not the best response. The ERASE model encourages a supportive environment. Leaving the situation without checking in with the nursing staff does not promote support, nor does it close the loop on how to best follow up with Veteran Pickens. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario3VideoSegments.mentorKeys.BnScn03All109]
		}, {
			title: 'Option 2',
			mentorVid: scenario3VideoSegments.mentorVidUrl,
			mentorOption: [scenario3VideoSegments.mentorKeys.BnScn03All087, scenario3VideoSegments.mentorKeys.BnScn03All088],
			isCorrect: true,
			description: 'You utilize supportive statements with your peers such as: “Wow, that felt like a lot. How are you two doing?”',
			feedbackHtml: 'Correct! You are utilizing the S in ERASE. You are supporting your peers and recognizing that there was a lot of feelings both from the Veteran and what they may be experiencing. It is key to encouraging a supportive environment by following up with the experiencer so they can process how they are feeling, and ensure they get what they need to improve the situation both immediately and in the future.',
			mentorFeedback: [scenario3VideoSegments.mentorKeys.BnScn03All091]
		}, {
			title: 'Option 3',
			mentorVid: scenario3VideoSegments.mentorVidUrl,
			mentorOption: [scenario3VideoSegments.mentorKeys.BnScn03All093, scenario3VideoSegments.mentorKeys.BnScn03All094],
			isCorrect: false,
			description: 'You state: "He clearly has some problems. Hope you two are OK because he sure is not."',
			feedbackHtml: 'Not the best answer! This is not an OK response. Being derogatory toward the Veteran is not helpful for the Veteran\'s recovery or for your peers. All people we engage are struggling. These statements could be seen as offensive, and they violate our I CARE values. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario3VideoSegments.mentorKeys.BnScn03All110]
		}, {
			title: 'Option 4',
			mentorVid: scenario3VideoSegments.mentorVidUrl,
			mentorOption: [scenario3VideoSegments.mentorKeys.BnScn03All098],
			isCorrect: true,
			description: 'You follow up with your peers about how they are feeling, and you assist in action planning what to do next to close the loop on communication with the treatment team and Veteran Pickens\' provider. You and the team devise a plan to talk with the Veteran to both address his needs and address his behaviors.',
			feedbackHtml: 'Correct! This response shows that you are both creating a culture of support and you are addressing Veteran Pickens care needs. This is a key part of the ERASE theory in order to provide support to all the parties involved.',
			mentorFeedback: [scenario3VideoSegments.mentorKeys.BnScn03All101]
		}]
		this.uiWrapper.displayQuestonType1UI({
			title: PageType.Scenario3,
			subtitle: ('Question 4'),
			audioUrl: null,
			options:options,
			multipleChoice: false,
			questionTitle: 'Select the response that best aligns with your action. There is more than one appropriate response.',
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario3VideoSegments.getItemByKey('Feedback');
				this.onQuestionType1Submitted(allOptions, selectedChoices, parentQuestionConfig,
												 () => { //Next Step (if correct)
													this.step11();
												 }, (optionsToShow: GeneralQuestionUIConfigOption[]) => { //Next Step (if incorrect)
													this.step10(optionsToShow);
												 }, mentorInfo.src);
			}
		}, 3, 4, () => this.step10())
	}

	//11.	to step 12 (video removed. no part 5)
	step11() {
		this.playVideoChapter(this.partId, scenario3VideoSegments.cinematicKeys.chapter4Resume, () => {
			this.step12();
		}, false)
	}

	//12.	Scenario Recap
	step12() {
		updateMentorVideo(false, scenario3VideoSegments.mentorVidUrl, scenario3VideoSegments.mentorKeys.BnScn03All103);
		this.setAreaForCurrentScenario(4, 5).then(() => {
			this.uiWrapper.displayIntroScreenUI({
				title: 'Scenario Completed',
				buttonText: 'Continue',
				htmlData: `
				<div>
					<div>
						<p class="black-text">
							In this section you reviewed options that are consistent with the ERASE model. ERASE stands for:
						<br />
						<ul class="bullet">
							<li class="black-text">E=Expecting that negative events can occur so you can prepare for them.</li>
							<li class="black-text">R=Recognize when sights, sounds, and behaviors cross over.</li>
							<li class="black-text">A=Addressing the situation in real time.</li>
							<li class="black-text">S=Support colleagues after an incident.</li>
							<li class="black-text">E=Encourage a supportive and psychologically safe environment.</li>
						</ul>
						</p>
					</div>
					<br />
					<p class="black-text">
						You were prepared by taking various trainings like the bystander training so you knew the four D's: Direct, Distract, Delegate, and Document.
					<br />
					<ul class="bullet">
						<li class="black-text">Necessary to address inappropriate behaviors in real time versus avoidance.</li>
						<li class="black-text">Maintain a respectful interaction with the Veteran utilizing clear expectations.</li>
						<li class="black-text">Unless safety requires, do not begin with the most escalated response to redirect Veteran engagement.</li>
						<li class="black-text">Check in with those that are getting harassed to see if they could use support.</li>
					</ul>
					</p>
				</div>
				`,
				audioUrls: null,
				onStartScenarioClicked: () => {
					this.step13();
				}
			})
		})
	}

	//13.	AAR
	step13() {
		Tools.getSaveData().then((savedData: CustomGameDataManager) => {
			savedData.data.scenarios[this.scenarioIndex()].isCompleted = true;
			Tools.saveGame(savedData).then(() => {
				this.uiWrapper.displayAAR(PageType.Scenario4);
			})
		})
	}
}